import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabelSemantic_getInstance4iffxvo6ijig as LabelSemantic_getInstance,
  LabeledViewseav57tyecmf as LabeledView,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { textPopover3tarprbgmgxbr as textPopover } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_name() {
  var tmp0_elvis_lhs = getKClassFromExpression(this).get_simpleName_r6f8py_k$();
  return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
}
function priority(context, module_0) {
  return 1.0;
}
function columnWidth(context, module_0) {
  return null;
}
function cellView(context, value, module_0) {
  return this.view_bqdmap_k$(context, value, module_0);
}
function cellForm(context, value, module_0) {
  return module_0.defaultCellForm_qf3kck_k$(context, value, this);
}
function labeledForm(context, value, module_0, label, description) {
  return (_this__u8e3s4) => {
    var tmp2 = label;
    // Inline function 'com.lightningkite.kiteui.forms.fieldWithDescription' call
    var description_0 = description;
    if (description_0 == null) {
      // Inline function 'com.lightningkite.kiteui.views.l2.field' call
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(_this__u8e3s4.get_context_h02k06_k$());
      ensureOutermostElement(element);
      _this__u8e3s4.willAddChild_hz2iwc_k$(element);
      element.set_content_lzqutq_k$(tmp2);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var $this$fieldWithDescription = themed(element, FieldSemantic_getInstance());
      this.form_gie6yk_k$(context, value, module_0)($this$fieldWithDescription);
      errorText(element);
      element.onStartup_vrxh3i_k$();
      _this__u8e3s4.addChild_2qpft2_k$(element);
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(true);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(element_0.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element_0.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(false);
      element_1.set_gap_jwjroq_k$(get_rem(0.25));
      text(themed(element_1, LabelSemantic_getInstance()), tmp2);
      var tmp0 = textPopover(element_1, description_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (IconView())(tmp0.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      tmp0.willAddChild_hz2iwc_k$(element_2);
      element_2.set_source_3o5lkf_k$(icon);
      element_2.set_description_s1386w_k$('Info');
      element_2.onStartup_vrxh3i_k$();
      tmp0.addChild_2qpft2_k$(element_2);
      element_1.onStartup_vrxh3i_k$();
      element_0.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var $this$fieldWithDescription_0 = themed(element_0, FieldSemantic_getInstance());
      this.form_gie6yk_k$(context, value, module_0)($this$fieldWithDescription_0);
      element_0.onStartup_vrxh3i_k$();
      _this__u8e3s4.addChild_2qpft2_k$(element_0);
    }
    return Unit_instance;
  };
}
function labeledView(context, value, module_0, label, description) {
  return (_this__u8e3s4) => {
    var tmp2 = label;
    // Inline function 'com.lightningkite.kiteui.forms.fieldWithDescription' call
    var description_0 = description;
    if (description_0 == null) {
      // Inline function 'com.lightningkite.kiteui.views.l2.field' call
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.l2.label' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(_this__u8e3s4.get_context_h02k06_k$());
      ensureOutermostElement(element);
      _this__u8e3s4.willAddChild_hz2iwc_k$(element);
      element.set_content_lzqutq_k$(tmp2);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var $this$fieldWithDescription = themed(element, FieldSemantic_getInstance());
      this.view_bqdmap_k$(context, value, module_0)($this$fieldWithDescription);
      errorText(element);
      element.onStartup_vrxh3i_k$();
      _this__u8e3s4.addChild_2qpft2_k$(element);
    } else {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      _this__u8e3s4.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(true);
      element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(LabelGapSemantic_getInstance()));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (RowOrCol())(element_0.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      element_0.willAddChild_hz2iwc_k$(element_1);
      element_1.set_vertical_nuap32_k$(false);
      element_1.set_gap_jwjroq_k$(get_rem(0.25));
      text(themed(element_1, LabelSemantic_getInstance()), tmp2);
      var tmp0 = textPopover(element_1, description_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      var icon = Companion_getInstance().info_1.resize_q1xpz0_k$(get_rem_0(1));
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (IconView())(tmp0.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      tmp0.willAddChild_hz2iwc_k$(element_2);
      element_2.set_source_3o5lkf_k$(icon);
      element_2.set_description_s1386w_k$('Info');
      element_2.onStartup_vrxh3i_k$();
      tmp0.addChild_2qpft2_k$(element_2);
      element_1.onStartup_vrxh3i_k$();
      element_0.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var $this$fieldWithDescription_0 = themed(element_0, FieldSemantic_getInstance());
      this.view_bqdmap_k$(context, value, module_0)($this$fieldWithDescription_0);
      element_0.onStartup_vrxh3i_k$();
      _this__u8e3s4.addChild_2qpft2_k$(element_0);
    }
    return Unit_instance;
  };
}
var RendererClass;
function Renderer() {
  if (RendererClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Renderer');
    RendererClass = $;
  }
  return RendererClass;
}
//region block: exports
export {
  cellForm as cellFormub3o1hqp20e5,
  cellView as cellView255m1dxiud5di,
  labeledForm as labeledForm2ame2d0a5lql9,
  labeledView as labeledView3rpvir7z2o9ii,
  priority as priority2y7gf37j4tged,
  Renderer as Renderer1fhwti5gmwutm,
};
//endregion

//# sourceMappingURL=Renderer.mjs.map
